import ThisModule from "./PageDashboard";

export default ThisModule;
